import { createTheme } from '@wikifactory/voxel-ui';

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#0f2eff',
    },
  },
  typography: {
    fontFamily: '"HelveticaNowDisplay", Helvetica, sans-serif',

    allVariants: {
      fontFamily: '"HelveticaNowDisplay", Helvetica, sans-serif',
    },
  },
});
